import Global from './Global';

const ACTION = {
  ...Global.ACTION
};

const ACTION_TYPES = {
  ...Global.ACTION_TYPES
};

const Index = {
  ACTION,
  ACTION_TYPES
}

export default Index;